export const filter = {
    id: null,
    user_id: null,
    conclusion_id: null,
    patient_id: null,
    search: "",
    created_at: "",
};
